/**
 * @author guan
 * @description 地图定位信息
 *
 *  new Location() 定义一个定位信息
 * @return void
 */
export default class Location {
    /** 表示经度 */
    private _longitude = 120.591586;
    /** 表示纬度 */
    private _latitude = 33.20745;
    /** 定位/不定位 */
    private _MARK_MODE = false;
    /** 表示一个记录值 */
    public marker_position = {
        lng: 120.591586,
        lat: 33.20745,
    };
    /**
     * @author guan
     * @description 纬度存取器
     * @return void
     */
    get latitude(): number {
        return this._latitude;
    }

    set latitude(value: number) {
        this._latitude = Number(value);
    }
    /**
     *
     */
    get MARK_MODE(): boolean {
        return this._MARK_MODE;
    }

    set MARK_MODE(value: boolean) {
        this._MARK_MODE = value;
    }

    /**
     *
     */
    get longitude(): number {
        return this._longitude;
    }

    set longitude(value: number) {
        this._longitude = Number(value);
    }
}
